import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/auth.service';
import { Setting, SettingType } from '../../shared/interfaces';
import { SettingService } from '../setting.service';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.scss'],
})
export class SettingFormComponent implements OnInit {
  setting = {} as Setting;
  form: UntypedFormGroup;
  SettingType = SettingType;
  types = [
    { value: SettingType.STRING, label: 'String' },
    { value: SettingType.MULTILINE_STRING, label: 'Multiline' },
    { value: SettingType.NUMBER, label: 'Number' },
    { value: SettingType.BOOLEAN, label: 'Boolean' },
    // { value: SettingType.DATE, label: 'Date' },
    // { value: SettingType.JSON, label: 'JSON' },
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public settingService: SettingService,
    public authService: AuthService,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      key: ['', [Validators.required]],
      value: ['', [Validators.required, this.validateValue.bind(this)]],
      type: ['', [Validators.required]],
      description: ['', []],
      readOnly: [false],
      visibleToInspector: [false],
    });

    this.form.get('type').valueChanges.subscribe((type: SettingFormComponent['types'][number]) => {
      switch (type.value) {
        case SettingType.STRING:
        case SettingType.MULTILINE_STRING:
          this.form.get('value').setValue(this.setting.value);
          break;

        case SettingType.BOOLEAN:
          this.form.get('value').setValue(!!this.setting.value);
          break;

        case SettingType.NUMBER:
          this.form.get('value').setValue(Number(this.setting.value));
          break;
      }
    });

    this.route.data.subscribe(async (data: { setting: Setting }) => {
      if (data.setting) {
        this.setting = data.setting;
        this.setData(data.setting);
      }
    });
  }

  validateValue(control) {
    const type = this.form && this.form.get('type').value;
    if (!type) {
      return null;
    }

    switch (type.value) {
      case SettingType.STRING:
      case SettingType.MULTILINE_STRING:
        return null;

      case SettingType.BOOLEAN:
        return control.value === true || control.value === false ? null : { invalid: true };

      case SettingType.NUMBER:
        return Number(control.value) ? null : { invalid: true };
    }
  }

  setData(data: Setting) {
    this.form.patchValue({
      ...data,
      type: this.types.find(t => t.value === data.type),
    });
    this.form.markAsUntouched();
    this.form.markAsPristine();
    if (data.readOnly) {
      this.form.disable();
    }
  }

  async submit() {
    const value = {
      ...this.form.value,
      type: this.form.value.type.value,
    };

    if (this.setting.id) {
      try {
        this.setting = await this.settingService.edit(this.setting.id, value);
        this.setData(this.setting);
        this.toastr.success('Setting saved!');
      } catch (e) {
        console.log('error edit', e);
      }
    } else {
      try {
        const setting = await this.settingService.create(value);
        this.router.navigate(['/setting/form', setting.id]);
        this.toastr.success('Setting saved!');
      } catch (e) {
        console.log('error create', e);
      }
    }
  }

  getValidationClass(field: string) {
    const control = this.form.get(field);
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }
}
